export const GUEST_CHECKOUT_CONTEXT_HEADER = "X-Schaeffler-Guest-Checkout-Context";

/**
 * Captures the one-time browser handoff fragment for page-data and scrubs it
 * before any request or redirect can expose the workflow credential in a URL.
 */
export function consumeGuestCheckoutContextFragment(): string | undefined {
  if (typeof window === "undefined" || !window.location.hash) {
    return undefined;
  }

  const context = new URLSearchParams(window.location.hash.slice(1)).get("guestCheckoutContext") ?? undefined;
  if (context) {
    window.history.replaceState({}, document.title, `${window.location.pathname}${window.location.search}`);
  }
  return context;
}
